module.exports = __webpack_public_path__ + "static/img/xiliniu.969b06bf.jpg";